// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"ec88ceaf","839":"c0942aac"}[chunkId] + ".chunk.js";
};